<template>
  <router-link :to="`${router}/${id}`" class="e-unitCard--link">
    <v-card class="e-unitCard e-elevation--5 e-border--radius">
      <v-card-title class="primary-gradiente text-xs-center justify-center d-flex">
        <h4 class="e-sub-sub-title white--text"> {{ unidadInfo }}</h4>
      </v-card-title>
      <v-card-text>
        <p class="e-description-middle" v-html="descripcion"></p>
      </v-card-text>
    </v-card>
  </router-link>
</template>

<script>
export default {
  props: {
    id: {
      type: Number
    },
    router: {
      type: String,
      default: '/unidad/detalle'
    },
    unidadInfo: {
      type: String,
      default: ''
    },
    descripcion: {
      type: String,
      default: ''
    }
  }
}
</script>
